import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../utils/mq';
import { useTranslation } from '../utils/translation';
import Con from '../icons/con';
import Pro from '../icons/pro';

export interface ProsAndConsProps {
  pros?: string[];
  cons?: string[];
  hideTitle?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      flex-direction: row;
      gap: 60px;
    `,
  )}
`;

const Title = styled.div`
  font-family: var(--theme-typography-primary-font);
  font-size: 18px;
  font-weight: bold;
`;

const LeftSide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 15px;
`;

const RightSide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 15px;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  gap: 12px;
  list-style: none;

  svg {
    min-width: 22px;
  }
`;

const ProItem = styled.li`
  display: flex;
  gap: 7px;
  line-height: 22px;
`;

const ConItem = styled.li`
  display: flex;
  gap: 7px;
  line-height: 22px;
`;

export const ProsAndCons = ({ ...props }: ProsAndConsProps) => {
  const { pros, cons, hideTitle } = props;
  const t = useTranslation();

  return (
    <Wrapper>
      {pros?.length > 0 ? (
        <LeftSide>
          {!hideTitle && <Title>{t('design.ratingBlock.pros')}</Title>}
          <List>
            {pros?.map((pro: string) => (
              <ProItem key={pro}>
                <Pro height={22} width={22} color="var(--theme-palette-green)" />
                {pro}
              </ProItem>
            ))}
          </List>
        </LeftSide>
      ) : null}
      {cons?.length > 0 ? (
        <RightSide>
          {!hideTitle && <Title>{t('design.ratingBlock.cons')}</Title>}
          <List>
            {cons?.map((con: string) => (
              <ConItem key={con}>
                <Con height={22} width={22} color="var(--theme-palette-red)" />
                {con}
              </ConItem>
            ))}
          </List>
        </RightSide>
      ) : null}
    </Wrapper>
  );
};
